import { Box, CircularProgress } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CreateUserLoginRequest } from "services/KnowfullyAdminClient";

const ImpersonateRedirectPage = () => {
  const { userId } = useParams<{ userId: string }>();
  const {
    userService,
    organizationUserService,
    usersListUrl,
  } = useGlobalContext();
  const navigate = useNavigate();

  useEffect(() => {
    const impersonate = async () => {
      try {
        const userDetails = await organizationUserService.getOrganizationUserDetails(
          userId!
        );

        if (!userDetails?.id || !userDetails?.organizationId) {
          navigate(
            `${usersListUrl()}?error=true&message=${encodeURIComponent(
              "User not found or missing organizationId"
            )}`
          );
          return;
        }

        const request = new CreateUserLoginRequest({
          userId: userDetails.id,
          organizationId: userDetails.organizationId,
        });

        const response = await userService.impersonateUser(request);

        if (response.redirectUrl) {
          window.location.href = response.redirectUrl;
        } else {
          navigate(
            `${usersListUrl()}?error=true&message=${encodeURIComponent(
              "No redirect URL received"
            )}`
          );
        }
      } catch (error: any) {
        const errorMessage =
          error?.response?.responseReason ||
          error?.message ||
          "Failed to impersonate user";

        navigate(
          `${usersListUrl()}?error=true&message=${encodeURIComponent(
            errorMessage
          )}`
        );
      }
    };

    if (userId) {
      impersonate();
    } else {
      navigate(
        `${usersListUrl()}?error=true&message=${encodeURIComponent(
          "No user ID provided"
        )}`
      );
    }
  }, [userId, userService, organizationUserService, navigate, usersListUrl]);

  return (
    <Box textAlign="center" my={2} width="100%">
      <CircularProgress />
    </Box>
  );
};

export default ImpersonateRedirectPage;
